
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_b6i01_145",
  "disabled": "awsui_disabled_16mm3_b6i01_160",
  "expandable-header": "awsui_expandable-header_16mm3_b6i01_164",
  "rolled-down": "awsui_rolled-down_16mm3_b6i01_175",
  "highlighted": "awsui_highlighted_16mm3_b6i01_178",
  "is-focused": "awsui_is-focused_16mm3_b6i01_196",
  "visual-refresh": "awsui_visual-refresh_16mm3_b6i01_199",
  "category": "awsui_category_16mm3_b6i01_203",
  "expandable": "awsui_expandable_16mm3_b6i01_164",
  "variant-navigation": "awsui_variant-navigation_16mm3_b6i01_218",
  "expand-icon": "awsui_expand-icon_16mm3_b6i01_225",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_b6i01_242",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_b6i01_245",
  "items-list-container": "awsui_items-list-container_16mm3_b6i01_253",
  "in-dropdown": "awsui_in-dropdown_16mm3_b6i01_262"
};
  